export default __webpack_public_path__ + "static/media/order-tracking.d54fe76d.png";